import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            sidebar: {
                myProfile: "My Profile",
                submissionInbox: "Inbox",
                students: "Students",
                courses: "Courses",
                workbench: {
                    header: "Workbench",
                    courses: "Course Builder",
                    lessons: "Lessons",
                },
                admin: {
                    header: "Administration",
                    users: "Users",
                    courses: "Courses",
                }
            },
            login: {
                projectPeriod: "2023 - 2026",
            },
            add: "Add",
            success: "Success",
            error: "Error",
            warning: "Warning",
            info: "Info",
            submit: "Submit",
            create: "Create",
            cancel: "Cancel",
            published: "Published",
            publish: "Publish",
            draft: "Draft",
            save: "Save",
            edit: "Edit",
            details: "Details",
            enroll: "Enroll",
            profile: {
                header: "My Profile",
                updated: {
                    success: "Profile updated successfully",
                },
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email",
            },
            courses: {
                header: "Courses",
                subHeader: "List of courses",
                instructor: "Instructor",
                tabs: {
                    overview: "Course",
                    students: "Students",
                },
            },
            submissions: {
                addSubmission: "Add Submission",
                add: {
                    title: "Title",
                    titleMissingWarning: "Title is required",
                    description: "Description",
                    descriptionMissingWarning: "Description is required",
                    uploadFile: "Upload File"
                },
                inboxTable: {
                    header: "Submission Inbox",
                    student: "Student",
                    status: "Status",
                    lesson: "Lesson",
                }
            },
            teacherDashboard: {
                header: "Teacher Dashboard",
                openCourseDetails: "Open Course Details",
            },
            workbench: {
                courses: {
                    header: "Courses",
                    subHeader: "List of courses",
                    newCourse: "New Course",
                    createCourse: "Create Course",
                    addStep: "Add Step",
                    notifications: {
                        courseCreated: "Course created successfully",
                        courseNotCreated: "Course not created. Something went wrong",
                    },
                    create: {
                        courseName: "Course Name",
                        courseNameMissingWarning: "Course name is required",
                    }
                },
                lessons: {
                    header: "Lessons",
                    subHeader: "List of lessons",
                    create: {
                        title: "Title",
                        description: "Description",
                        componentType: "Component Type",
                    }
                },
            },
            admin: {
                users: {
                    header: "Users",
                    filter: {
                        all: "All",
                        admin: "Admins",
                        teacher: "Teachers",
                        student: "Students",
                    },
                    roles: {
                        admin: "Admin",
                        teacher: "Teacher",
                        student: "Student",
                    },
                    list: {
                        user: "User",
                        roles: "Roles",
                        studyGroup: "Study group",
                        joined: "Joined",
                        empty: "No users found",
                    },
                },
                courses: {
                    header: "Courses",
                    preview: "Preview",
                    list: {
                        title: "Course",
                        author: "Author",
                        lessons: "Lessons",
                        enrolled: "Enrolled",
                        created: "Created",
                        empty: "No courses found",
                    },
                },
            },

        }
    },
    pl: {
        translation: {

            resetPassword: {
                header: "Zresetuj Hasło",
                success: "Sprawdź swoją skrzynkę e-mailową. Wysłaliśmy Ci link do zresetowania hasła",
                error: "Nie udało się zresetować hasła. Spróbuj ponownie",
                email: "E-mail",
                emailMissingWarning: "E-mail jest wymagany",
                submit: "Zresetuj Hasło",
            },
            sidebar: {
                myProfile: "Mój Profil",
                submissionInbox: "Skrzynka",
                students: "Studenci",
                courses: "Kursy",
                workbench: {
                    header: "Stół Roboczy",
                    courses: "Kreator kursów",
                    lessons: "Moduły",
                },
                admin: {
                    header: "Administracja",
                    users: "Użytkownicy",
                    courses: "Kursy",
                }
            },
            logout: "Wyloguj się",
            login: {
                login: "Zaloguj się",
                password: "Hasło",
                email: "E-mail",
                forgotPassword: "Zapomniałeś hasła?",
                projectPeriod: "2023 - 2026",
                emailMissingWarning: "E-mail jest wymagany",
                missingPasswordWarning: "Hasło jest wymagane",
                error: {
                    header: "Błąd",
                    subHeader: "Nie udało się zalogować. Spróbuj ponownie",
                }
            },
            open: "Otwórz",
            reject: "Odrzuć",
            approve: "Zatwierdź",
            enrolled: "Zapisany",
            coursePublished: "Kurs opublikowany pomyślnie",
            courseSaved: "Kurs zapisany pomyślnie",
            add: "Dodaj",
            success: "Sukces",
            error: "Błąd",
            warning: "Ostrzeżenie",
            info: "Informacja",
            submit: "Zatwierdź",
            create: "Utwórz",
            cancel: "Anuluj",
            published: "Opublikowane",
            publish: "Publikuj",
            draft: "Szkic",
            save: "Zapisz",
            edit: "Edytuj",
            details: "Szczegóły",
            enroll: "Zapisz się",
            update: "Aktualizuj",
            sww: "Coś poszło nie tak",
            waiting: "Oczekiwanie",
            approved: "Zatwierdzone",
            rejected: "Odrzucone",
            submitted: "Przesłane",
            profile: {
                header: "Mój Profil",
                updated: {
                    success: "Profil zaktualizowany pomyślnie",
                },
                firstName: "Imię",
                lastName: "Nazwisko",
                email: "E-mail",
            },
            uploadSubmission: {
                header: "Prześlij pracę",
                title: "Tytuł",
                titleMissingWarning: "Tytuł jest wymagany",
                description: "Opis",
                descriptionMissingWarning: "Opis jest wymagany",
                file: "Plik",
                fileMissingWarning: "Plik jest wymagany",
                selectFile: "Wybierz Plik",
                notifications: {
                    success: "Praca przesłana pomyślnie",
                }
            },
            courses: {
                header: "Kursy",
                subHeader: "Lista kursów",
                submissions: "Przesłane Prace",
                instructor: "Prowadzący",
                tabs: {
                    overview: "Kurs",
                    students: "Studenci",
                },
            },
            submissions: {
                addSubmission: "Dodaj Zgłoszenie",
                add: {
                    title: "Tytuł",
                    titleMissingWarning: "Tytuł jest wymagany",
                    description: "Opis",
                    descriptionMissingWarning: "Opis jest wymagany",
                    uploadFile: "Prześlij Plik"
                },
                inboxTable: {
                    header: "Skrzynka Zgłoszeń",
                    student: "Student",
                    status: "Status",
                    lesson: "Moduł",
                }
            },
            teacherDashboard: {
                header: "Panel Prowadzącego",
                openCourseDetails: "Otwórz Szczegóły Kursu",
            },
            workbench: {
                courses: {
                    header: "Kursy",
                    subHeader: "Lista kursów",
                    newCourse: "Nowy Kurs",
                    createCourse: "Utwórz Kurs",
                    addStep: "Dodaj Krok",
                    notifications: {
                        courseCreated: "Kurs utworzony pomyślnie",
                        courseNotCreated: "Nie udało się utworzyć kursu. Coś poszło nie tak",
                    },
                    create: {
                        courseName: "Nazwa Kursu",
                        courseNameMissingWarning: "Nazwa kursu jest wymagana",
                    }
                },
                lessons: {
                    notebooks: {
                        header: "Notatniki",
                    },
                    dashboard: {
                        header: "Moduły",
                        resources: "Zasoby",
                    },
                    newLesson: "Nowy Moduł",
                    header: "Moduły",
                    subHeader: "Lista modułów",
                    create: {
                        header: "Utwórz Moduł",
                        title: "Tytuł",
                        description: "Opis",
                        componentType: "Typ Komponentu",
                    },
                    update: {
                        header: "Edytuj Moduł",
                        title: "Tytuł",
                        description: "Opis",
                        componentType: "Typ Komponentu",
                        externalLinks: "Linki Zewnętrzne",
                        addExternalLink: "Dodaj Link Zewnętrzny",
                        files: "Pliki",
                        addFile: "Dodaj Plik",

                    },
                    notifications: {
                        lessonCreated: "Moduł utworzony pomyślnie",
                        lessonNotCreated: "Nie udało się utworzyć modułu. Coś poszło nie tak",
                        descriptionUpdated: "Opis zaktualizowany pomyślnie",
                        sww: "Coś poszło nie tak",
                    },
                    errors: {
                        titleMissing: "Tytuł jest wymagany",
                        descriptionMissing: "Opis jest wymagany",
                        componentTypeMissing: "Typ komponentu jest wymagany",
                    }
                },
            },
            users: {
                students: {
                    list: {
                        header: "Studenci",
                        student: "Student",
                        courses: "Kursy",
                        progress: "Postęp",
                        submissions: "Prace",
                        grade: "Ocena",
                        averageGrade: "śr. {{grade}}",
                        lastActivity: "Ostatnia aktywność",
                        needsAttention: "Wymaga uwagi",
                        pendingSubmissions: "{{count}} do sprawdzenia",
                        empty: "Brak studentów przypisanych do Twoich kursów",
                        attention: {
                            no_submission: "Brak pracy",
                            pending_review: "Do sprawdzenia",
                            low_grade: "Niska ocena",
                        },
                    }
                },
                create: {
                    header: "Utwórz Użytkownika",
                    firstName: "Imię",
                    lastName: "Nazwisko",
                    email: "E-mail",
                    password: "Hasło",
                    role: "Rola",
                    create: "Utwórz",
                    notifications: {
                        userCreated: "Użytkownik utworzony pomyślnie",
                    },
                    errors: {
                        firstNameMissing: "Imię jest wymagane",
                        lastNameMissing: "Nazwisko jest wymagane",
                        emailMissing: "E-mail jest wymagany",
                        passwordMissing: "Hasło jest wymagane",
                        sww: "Coś poszło nie tak",
                    }
                }
            },
            admin: {
                users: {
                    header: "Użytkownicy",
                    filter: {
                        all: "Wszyscy",
                        admin: "Administratorzy",
                        teacher: "Prowadzący",
                        student: "Studenci",
                    },
                    roles: {
                        admin: "Administrator",
                        teacher: "Prowadzący",
                        student: "Student",
                    },
                    list: {
                        user: "Użytkownik",
                        roles: "Role",
                        studyGroup: "Grupa",
                        joined: "Dołączył",
                        empty: "Nie znaleziono użytkowników",
                    },
                },
                courses: {
                    header: "Kursy",
                    preview: "Podgląd",
                    list: {
                        title: "Kurs",
                        author: "Autor",
                        lessons: "Moduły",
                        enrolled: "Zapisani",
                        created: "Utworzono",
                        empty: "Nie znaleziono kursów",
                    },
                },
            }
        }
    }

};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "pl", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
